import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AuthService } from './core/auth/auth.service';
// import SecureLS from 'secure-ls';
import { ApiService } from './providers/api.service';
// var ls = new SecureLS({ encodingType: 'base64' });
import ls from 'localstorage-slim';
import { Title } from '@angular/platform-browser';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    idleState = 'Not started.';
    timedOut = false;
    lastPing?: Date = null;
    configForm: FormGroup;
    dialogRef: any;
    idleWindowShown = false;
    isLoggedIn: boolean = false;


    /**
     * Constructor
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private _router: Router,
        private _fuseConfirmationService: FuseConfirmationService,
        private idle: Idle, private keepalive: Keepalive,
        private _authService: AuthService,
        private apiSrvc: ApiService,
        private titleService: Title
    ) {
        // sets an idle timeout of 30 minutes, for testing purposes.
        idle.setIdle(60 * 30);
        // sets a timeout period of 30 seconds. after 30 seconds of inactivity, the user will be considered timed out.
        idle.setTimeout(30);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        idle.onIdleEnd.subscribe(() => {
            console.log("No longer idle");
            if(this.dialogRef)
            {
                this.dialogRef.close();
            }
           
            this.idleWindowShown = false;
        });
        idle.onTimeout.subscribe(() => {
            this.idleState = 'Timed out!';
            this.timedOut = true;
        });
        idle.onIdleStart.subscribe(() => {
            this.idleState = 'You\'ve gone idle!';
            this.idleWindowShown = true;
            this.openConfirmationDialog();
        });
        idle.onTimeoutWarning.subscribe((countdown) => {
            if (countdown == 1 && this.isLoggedIn == true) {
                console.log('You will sign out in ' + countdown + ' seconds!');
                this.dialogRef.close();
                this.signOut();
            }
        });

        // sets the ping interval to 15 seconds
        // keepalive.interval(15);

        keepalive.onPing.subscribe(() => this.lastPing = new Date());

        this.reset();


    }

    /**
     * On init
     */
    ngOnInit(): void {
        this.getOriginDtails();
        // this.apiSrvc.showDailogeBox('Confirm Alert!', 'Are you sure delete?', [{ title: 'Ok', cb_res: 200 }], (btn_res) => {
        //     console.log(btn_res)
        // })
        // Build the config form
        this.configForm = this._formBuilder.group({
            title: 'Your session is gone idle',
            message: 'You will be logged out in 30 seconds <br><span class=\"font-medium\">Please move your mouse/perform an action to keep this active.</span>',
            icon: this._formBuilder.group({
                show: true,
                name: 'heroicons_outline:exclamation',
                color: 'warn'
            }),
            actions: this._formBuilder.group({
                confirm: this._formBuilder.group({
                    show: true,
                    label: 'Keep Alive',
                    color: 'primary'
                }),
                cancel: this._formBuilder.group({
                    show: true,
                    label: 'Logout'
                })
            }),
            dismissible: true
        });

        let localJson: string = ls.get('hms_loggedin_user');
        try {
            if (localJson && localJson != 'undefined') {
                let user = JSON.parse(localJson);
                let theme = user.thme_nm; this._fuseConfigService.config = { theme };
                let layout = user.lyt_nm; this._fuseConfigService.config = { layout };
            }
        } catch (e) {
            localStorage.clear()
            console.log("LOGING`")
        }


    }
    reset() {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
    }
    /**
     * Sign out
     */
    signOut(): void {
        this._router.navigate(['/sign-out']);
    }
    /**
* Open confirmation dialog
*/
    openConfirmationDialog(): void {
        let localJson = ls.get('hms_loggedin_user');
        if (localJson && localJson != 'undefined') {
            this.isLoggedIn = true;
        } else {
            this.isLoggedIn = false;
        }

        // Open the dialog and save the reference of it
        if (this.idleWindowShown == true && this.isLoggedIn == true) {
            this.dialogRef = this._fuseConfirmationService.open(this.configForm.value);
            // Subscribe to afterClosed from the dialog reference
            this.dialogRef.afterClosed().subscribe((result) => {
                if (result == "confirmed") {
                    console.log("Keep Alive");
                } else if (result == "cancelled") {
                    this.signOut();
                } else {
                    console.log("Closed with out button");
                }
                this.reset();
                this.idleWindowShown = false;
            });
        }
    }

    //   hideChildModal(): void {
    //     this.childModal.hide();
    //   }

    //   stay() {
    //     this.childModal.hide();
    //     this.reset();
    //   }

    //   logout() {
    //     this.childModal.hide();
    //     this.appService.setUserLoggedIn(false);
    //     this.router.navigate(['/']);
    //   }
    // ngOnInit(){

    // }

    getOriginDtails(): void {
        this._authService.getUrlBasedbannel()
            .subscribe({
                next: (response) => {
                    console.log(response);
                   
                    if (response && response[`data`].length > 0) {
                        localStorage.setItem('banner_dtls', JSON.stringify(response[`data`][0]))
                        this.titleService.setTitle(response[`data`][0].app_ttle_txt);
                    } else {

                        this.titleService.setTitle('WMS - By Dreamstep');
                    }
                },
                error: (error) => {

                    this.titleService.setTitle('WMS - By Dreamstep');
                }
            });
    }

}
